import { Entity } from '@backstage/catalog-model';
import {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';
import { usePracticeShaperGraphData } from '../hooks/practice-shaper-graph/usePracticeShaperGraphData';

export type PracticeShaperGraphProps = {
  data: ReturnType<typeof usePracticeShaperGraphData>;
  filteredRelations: string[];
  setFilteredRelations: Dispatch<SetStateAction<string[]>>;
  selectedEntity: Entity | null;
  setSelectedEntity: Dispatch<SetStateAction<Entity | null>>;
};

export const PracticeShaperGraphContext =
  createContext<PracticeShaperGraphProps>({} as PracticeShaperGraphProps);

interface Props {
  children?: ReactNode;
}

const DEFAULT_EXCLUDED_RELATIONS = [
  'hasPart',
  'hasChild',
  'readBy',
  'extendedBy',
  'evolvedBy',
];

export const HIGHLIGHTED_RELATIONS = ['partOf', 'belongsTo'];

export const PracticeShaperGraphProvider: FC<Props> = ({ children }) => {
  const data = usePracticeShaperGraphData();
  const [filteredRelations, setFilteredRelations] = useState(
    DEFAULT_EXCLUDED_RELATIONS,
  );

  const [selectedEntity, setSelectedEntity] = useState<Entity | null>(null);

  return (
    <PracticeShaperGraphContext.Provider
      value={{
        data,
        filteredRelations,
        setFilteredRelations,
        selectedEntity,
        setSelectedEntity,
      }}
    >
      {children}
    </PracticeShaperGraphContext.Provider>
  );
};

export const usePracticeShaperGraph = () =>
  useContext(PracticeShaperGraphContext);
